import { Vector3 } from "three";
/**
 * Provides image utility functions
 * @class ImageUtils
 */
export class ImageUtils {
    /**
     * Shows the array as image in a new popup
     */
    static ShowImage(img) {
        const can = document.createElement("canvas");
        const ctx = can.getContext("2d");
        const imgWidth = img.length;
        const imgHeight = img[0].length;
        can.width = imgWidth;
        can.height = imgHeight;
        ctx.fillRect(0, 0, imgWidth, imgHeight);
        const imagedata = ctx.getImageData(0, 0, imgWidth, imgHeight);
        for (let j = 0; j < imgHeight; j++) {
            for (let i = 0; i < imgWidth; i++) {
                const value = (img[j][i] / 65535) * 255;
                imagedata.data[(imgWidth * i + j) * 4] = value;
                imagedata.data[(imgWidth * i + j) * 4 + 1] = value; //img[i][j];
                imagedata.data[(imgWidth * i + j) * 4 + 2] = value; //img[i][j];
            }
        }
        ctx.putImageData(imagedata, 0, 0);
        const dataURL = can.toDataURL("image/png");
        window.open(dataURL);
    }
    static FlattenImage(img) {
        const flatimage = [];
        const imgWidth = img.length;
        const imgHeight = img[0].length;
        for (let j = 0; j < imgHeight; j++) {
            for (let i = 0; i < imgWidth; i++) {
                flatimage[i * imgWidth + j] = img[i][j];
            }
        }
        return flatimage;
    }
    static DeflattenImage(flatimg, w, h) {
        const img = [];
        img[0] = [];
        const imgWidth = w;
        const imgHeight = h;
        for (let i = 0; i < imgHeight; i++) {
            img[i] = [];
            for (let j = 0; j < imgWidth; j++) {
                img[i][j] = flatimg[i * imgWidth + j];
            }
        }
        return img;
    }
    static Convolute(pixels, dstimageData, filtermask, opaque) {
        const side = Math.round(Math.sqrt(filtermask.length));
        const halfSide = Math.floor(side / 2);
        const src = pixels;
        const sw = dstimageData.width;
        const sh = dstimageData.height;
        // pad output by the convolution matrix
        const w = sw;
        const h = sh;
        const output = dstimageData;
        const dst = output.data;
        // go through the destination image pixels
        for (let y = 1; y < h - 1; y++) {
            for (let x = 1; x < w - 1; x++) {
                const sy = y;
                const sx = x;
                const dstOff = (y * w + x) * 4;
                // calculate the weighed sum of the source image pixels that
                // fall under the convolution matrix
                let r = 0, g = 0, b = 0, a = 0;
                for (let cy = 0; cy < side; cy++) {
                    for (let cx = 0; cx < side; cx++) {
                        const scy = sy + cy - halfSide;
                        const scx = sx + cx - halfSide;
                        if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                            const srcOff = (scy * sw + scx) * 4;
                            const wt = filtermask[cy * side + cx];
                            r += src[srcOff] * wt;
                            g += src[srcOff + 1] * wt;
                            b += src[srcOff + 2] * wt;
                            a += src[srcOff + 3];
                        }
                    }
                }
                dst[dstOff] = r;
                dst[dstOff + 1] = g;
                dst[dstOff + 2] = b;
                dst[dstOff + 3] = a;
            }
        }
        return output;
    }
    static Add(imgdata1, imgdata2) {
        const l1 = imgdata1.data.length;
        const l2 = imgdata2.data.length;
        if (l1 != l2)
            throw "mmImageUtils Add: ImageData1 and ImageData2 must be same sized.";
        for (let i = 0; i < l1; i++) {
            imgdata1.data[i] = imgdata1.data[i] + imgdata2.data[i];
        }
    }
    /**
     * Works only in RED-Channel !
     */
    static Threshold(imgdata, level) {
        const l1 = imgdata.data.length;
        for (let i = 0; i < l1; i = i + 4) {
            if (imgdata.data[i] > level) {
                imgdata.data[i] = 255;
            }
            else {
                imgdata.data[i] = 0;
            }
            imgdata.data[i + 1] = 0;
            imgdata.data[i + 2] = 0;
            imgdata.data[i + 3] = 255;
        }
    }
    /**
     * Get the last max
     * Works only in RED-Channel!
     * Returns just the position in imgdata array not the max!
     */
    static Max(imgdata, mark) {
        let max = 0;
        let pos = 0;
        const l1 = imgdata.data.length;
        for (let i = 0; i < l1; i = i + 4) {
            if (imgdata.data[i] > max) {
                max = imgdata.data[i];
                pos = i;
            }
        }
        if (mark) {
            imgdata.data[pos] = 255;
            imgdata.data[pos + 1] = 255;
            imgdata.data[pos + 2] = 255;
            imgdata.data[pos + 3] = 255;
        }
        return pos;
    }
    /**
     * Works only in RED-Channel!
     */
    static BiLinearInterpol(imgdata) {
        const w = imgdata.width;
        const h = imgdata.height;
        let valx = 0;
        let valy = 0;
        let dstOff = 0;
        for (let y = 0; y < h; y++) {
            for (let x = 0; x < w; x++) {
                dstOff = (y * w + x) * 4;
                if (x > 0.5 * w) {
                    valx = 2 - x / (0.5 * w);
                }
                else {
                    valx = x / (0.5 * w);
                }
                if (y > 0.5 * h) {
                    valy = 2 - y / (0.5 * h);
                }
                else {
                    valy = y / (0.5 * h);
                }
                const val = valx / 2 + valy / 2;
                imgdata.data[dstOff] = Math.round(val * imgdata.data[dstOff]);
                imgdata.data[dstOff + 1] = 0;
                imgdata.data[dstOff + 2] = 0;
                imgdata.data[dstOff + 3] = 255;
            }
        }
    }
    static ImgBufferIndexToRowCol(index, imgdata) {
        const w = imgdata.width;
        const a = Math.floor(index / 4) * 4; //red-channel
        const row = Math.floor(a / (4 * w));
        const col = (a - row * w * 4) / 4;
        return [row, col];
    }
    static RowColToImgBuffer(row, col, imgdata) {
        return (row * imgdata.width + col) * 4;
    }
    static Erode(imgdata, dstimagedata, structureelement) {
        const side = Math.round(Math.sqrt(structureelement.length));
        const halfSide = Math.floor(side / 2);
        const src = imgdata.data;
        const sw = imgdata.width;
        const sh = imgdata.height;
        // pad output by the convolution matrix
        const w = sw;
        const h = sh;
        const output = dstimagedata;
        const dst = output.data;
        // go through the destination image pixels
        for (let y = 0; y < h; y++) {
            for (let x = 0; x < w; x++) {
                const sy = y;
                const sx = x;
                const dstOff = (y * w + x) * 4;
                // calculate the weighed sum of the source image pixels that
                // fall under the convolution matrix
                let r = 255, g = 0, b = 0, a = 0;
                for (let cy = 0; cy < side; cy++) {
                    for (let cx = 0; cx < side; cx++) {
                        const scy = sy + cy - halfSide;
                        const scx = sx + cx - halfSide;
                        if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                            const srcOff = (scy * sw + scx) * 4;
                            if (src[srcOff] != 255) {
                                if (src[srcOff] > 100) {
                                    r = 128;
                                }
                                else {
                                    r = 0;
                                }
                            }
                            g = 0;
                            b = 0;
                            a = 255;
                        }
                    }
                }
                dst[dstOff] = r;
                dst[dstOff + 1] = g;
                dst[dstOff + 2] = b;
                dst[dstOff + 3] = a;
            }
        }
        return output;
    }
    /**
     * Surely the wrong place for this method....
     */
    static RansacLineFit(posarray) {
        if (posarray.length < 2)
            return null;
        let p1 = new Vector3();
        const p2 = new Vector3();
        const l = new Vector3();
        const pp = new Vector3();
        let lcross = new Vector3();
        let pp_p1 = new Vector3();
        let nl = 0;
        let nc = 0;
        let s = 0;
        const bestp1 = new Vector3();
        const bestp2 = new Vector3();
        const a = new Vector3();
        const b = new Vector3();
        const p = new Vector3();
        let numinliers = 0;
        const inlierthresh = 0.005;
        const ps = [];
        for (let i = 1; i < 100; i++) {
            //Pick tow arbitrary points
            const idx1 = Math.floor(Math.random() * posarray.length);
            const idx2 = Math.floor(Math.random() * posarray.length);
            if (idx1 == idx2)
                continue;
            p1.set(posarray[idx1]["Easting"], posarray[idx1]["Northing"], posarray[idx1]["Height"]);
            p2.set(posarray[idx2]["Easting"], posarray[idx2]["Northing"], posarray[idx2]["Height"]);
            l.copy(p1);
            p1 = p1.sub(p2);
            nl = l.length();
            s = 0;
            numinliers = 0;
            const inliermask = [];
            for (let j = 0; j < posarray.length; j++) {
                pp.set(posarray[j]["Easting"], posarray[j]["Northing"], posarray[j]["Height"]);
                pp_p1.copy(pp);
                pp_p1 = pp_p1.sub(p1);
                lcross.set(l.x, l.y, l.z);
                lcross = lcross.cross(pp_p1);
                nc = lcross.length();
                s = nc / nl;
                if (s < inlierthresh) {
                    numinliers++;
                    inliermask[j] = 1;
                }
                else {
                    inliermask[j] = 0;
                }
            }
            ps.push([numinliers, idx1, idx2]);
        }
        ps.sort(function (a, b) {
            return b[0] - a[0];
        });
        bestp1.set(posarray[ps[0][1]]["Easting"], posarray[ps[0][1]]["Northing"], posarray[ps[0][1]]["Height"]);
        bestp2.set(posarray[ps[0][2]]["Easting"], posarray[ps[0][2]]["Northing"], posarray[ps[0][2]]["Height"]);
        //project first point on best line
        a.copy(bestp2).sub(bestp1);
        p.set(posarray[0]["Easting"], posarray[0]["Northing"], posarray[0]["Height"]);
        b.copy(p);
        b.sub(bestp1);
        let ss = b.dot(a) / a.lengthSq();
        let aa = new Vector3().copy(a);
        aa.multiplyScalar(ss);
        aa = aa.add(bestp1);
        const len = posarray.length;
        p.set(posarray[len - 1]["Easting"], posarray[len - 1]["Northing"], posarray[len - 1]["Height"]);
        b.copy(p).sub(bestp1);
        ss = b.dot(a) / a.lengthSq();
        const zz = new Vector3().copy(a);
        zz.multiplyScalar(ss);
        zz.add(bestp1);
        return [
            [aa.x, aa.y, aa.z],
            [zz.x, zz.y, zz.z],
        ];
    }
    /**
     * @description QUELLE: http://de.wikipedia.org/wiki/Bresenham-Algorithmus
     */
    static GetLinePixelList(x0, y0, x1, y1) {
        const pixellist = [];
        const dx = Math.abs(x1 - x0), sx = x0 < x1 ? 1 : -1;
        const dy = -Math.abs(y1 - y0), sy = y0 < y1 ? 1 : -1;
        let err = dx + dy, e2; /* error value e_xy */
        // eslint-disable-next-line
        while (true) {
            /* loop */
            pixellist.push([y0, x0]);
            if (x0 == x1 && y0 == y1)
                break;
            e2 = 2 * err;
            if (e2 > dy) {
                err += dy;
                x0 += sx;
            }
            if (e2 < dx) {
                err += dx;
                y0 += sy;
            }
        }
        return pixellist;
    }
    static GetLineImgBufferIndex(x0, y0, x1, y1, imgbuffer) {
        const plist = ImageUtils.GetLinePixelList(x0, y0, x1, y1);
        const idx = [];
        for (let i = 0; i < plist.length; i++) {
            idx.push(ImageUtils.RowColToImgBuffer(plist[i][0], plist[i][1], imgbuffer));
        }
        return idx;
    }
    static SingleLineHoughTransform(x0, y0, x1, y1, imgbuffer) {
        const imgBorderPoints = ImageUtils.LineSegmentToFullLine(x0, y0, x1, y1, imgbuffer);
        //get Line trough the whole image(canvas)
        const plist = ImageUtils.GetLineImgBufferIndex(imgBorderPoints[0], imgBorderPoints[1], imgBorderPoints[2], imgBorderPoints[3], imgbuffer);
        let sum = 0;
        for (let i = 0; i < plist.length; i++) {
            if (plist[i] < imgbuffer.data.length) {
                sum = sum + imgbuffer.data[plist[i]];
            }
        }
        sum = sum / plist.length;
        return sum;
    }
    static BlackToTransparent(imgbuffer) {
        for (let i = 3; i < imgbuffer.data.length; i += 4) {
            if (imgbuffer.data[i - 1] == 0 && imgbuffer.data[i - 2] == 0 && imgbuffer.data[i - 3] == 0) {
                imgbuffer.data[i] = 0;
            }
            else {
                const rc = ImageUtils.ImgBufferIndexToRowCol(i, imgbuffer);
                imgbuffer.data[i] =
                    Math.min(1 - Math.sqrt(Math.pow(75 - rc[0], 2) + Math.pow(150 - rc[1], 2)) / 75, 1) * 255;
            }
        }
        return imgbuffer;
    }
    static applyGammaCorrection(image, gammaval) {
        const gammacorrectcanvas = document.createElement("canvas");
        gammacorrectcanvas.width = image.width;
        gammacorrectcanvas.height = image.height;
        const w = image.width;
        const h = image.height;
        const corrctx = gammacorrectcanvas.getContext("2d");
        corrctx.drawImage(image, 0, 0, w, h);
        //get the image data
        const imgdata = corrctx.getImageData(0, 0, Math.round(w), Math.round(h));
        const transimgdata = corrctx.createImageData(w, h);
        const gammatable = new Array(256);
        const og = 1.0 / gammaval;
        const inc = 0.003922; // 1/255
        let i = 0;
        let i2 = 0;
        do {
            gammatable[i] = ~~(Math.pow(i2, og) * 255);
            i++;
            i2 += inc;
            gammatable[i] = ~~(Math.pow(i2, og) * 255);
            i++;
            i2 += inc;
            gammatable[i] = ~~(Math.pow(i2, og) * 255);
            i++;
            i2 += inc;
            gammatable[i] = ~~(Math.pow(i2, og) * 255);
            i++;
            i2 += inc;
        } while (i <= 255);
        const len = transimgdata.data.length;
        const dst = transimgdata.data;
        const src = imgdata.data;
        let l = 0;
        do {
            dst[l] = gammatable[src[l]];
            l++;
            dst[l] = gammatable[src[l]];
            l++;
            dst[l] = gammatable[src[l]];
            l++;
            dst[l] = gammatable[src[l]];
            l++;
        } while (l < len);
        corrctx.putImageData(transimgdata, 0, 0);
        /* Set the gamma corrected canvas as image of this texture */
        return gammacorrectcanvas;
    }
}
/**
 * Expands a line defined by two points (x0,y0,x1,y1) to the image borders
 *
 * @param x0
 * @param y0
 * @param x1
 * @param y1
 * @param imgbuffer
 * @returns {Array}
 */
ImageUtils.LineSegmentToFullLine = function (x0, y0, x1, y1, imgbuffer) {
    const w = imgbuffer.width - 1;
    const h = imgbuffer.height - 1;
    const r1 = [x0, y0];
    const a1 = [x1 - x0, y1 - y0];
    const rs = [
        [0, 0],
        [0, h],
        [w, 0],
        [0, 0],
    ];
    const as = [
        [w, 0],
        [w, 0],
        [0, h],
        [0, h],
    ];
    const s = [];
    for (let i = 0; i < 4; i++) {
        const r2 = rs[i];
        const a2 = as[i];
        const p = 1 / (a1[0] * -a2[1] - -a2[0] * a1[1]);
        const d2 = p * -a1[1] * (r2[0] - r1[0]) + p * a1[0] * (r2[1] - r1[1]);
        if (d2 <= 1 && d2 >= -0.00000001) {
            s.push([a2[0] * d2 + r2[0], a2[1] * d2 + r2[1], d2]);
        }
    }
    const x0_b = Math.round(s[0][0]);
    const y0_b = Math.round(s[0][1]);
    const x1_b = Math.round(s[1][0]);
    const y1_b = Math.round(s[1][1]);
    return [x0_b, y0_b, x1_b, y1_b];
};
//# sourceMappingURL=imageutils.js.map